export default __webpack_public_path__ + "static/media/028-frog.a6060588.svg";